<template>
  <!-- eslint-disable max-len -->
  <section class="amp-offers">
    <h3 class="amp-offers__heading">
      Now, select up to $750 in savings
    </h3>
    <p class="amp-offers__body mt-2">
      Visit MYMOVE.com to choose your offers. Just check the box and click "Continue" to autofill your MYMOVE.com registration. You will be redirected from the USPS Change-of-Address website to MYMOVE.com, where you can verify your information.
    </p>
    <InputCheckbox
      id="amp-offers-temp-checkbox"
      v-model="autofill"
      name="autofill-offers-temp"
      class="c-input-checkbox--lg mt-6"
      @input="trackAutofill"
    >
      <p class="amp-offers__autofill-copy">
        By checking this box, you are voluntarily providing your consent to transfer a copy of your personal contact information to MYMOVE in order to autofill your MYMOVE registration.
      </p>
    </InputCheckbox>
    <p class="amp-offers__legal my-6">
      Once on MYMOVE.com, you will be subject to the MYMOVE Privacy Policy and Terms and Conditions.
    </p>
    <div class="c-navbar">
      <button
        id="continue-offers-temp"
        :class="{ 'c-btn--disabled': loading }"
        :disabled="loading"
        type="button"
        class="c-btn"
        @click="next"
      >
        Continue
      </button>
    </div>
  </section>
</template>

<script>
import { InputCheckbox } from '@mgo/ui';
import { track } from '../../analytics/events';
import { validateHandoffUrl } from '../../utils/commonUtil';

export default {
  name: 'OffersMobile',
  components: {
    InputCheckbox,
  },
  data() {
    return {
      autofill: false,
      loading: false,
    };
  },
  methods: {
    trackAutofill() {
      track('ElementClicked', {
        name: `autofill-toggled-${this.autofill ? 'on' : 'off'}`,
      });
    },
    async next(e) {
      this.loading = true;

      track('ElementClicked', { name: e.target.id });
      const { url } = await this.$coa.handoffGetURL('offers', this.autofill, this.$route.query);

      const validUrl = validateHandoffUrl(url);
      if (!validUrl) {
        this.loading = false;
        return;
      }
      window.location.href = validUrl;
    },
  },
};
</script>
